import { render } from "./VideoPlayerControls.vue?vue&type=template&id=1cddd22c&ts=true"
import script from "./VideoPlayerControls.vue?vue&type=script&lang=ts"
export * from "./VideoPlayerControls.vue?vue&type=script&lang=ts"

import "./VideoPlayerControls.vue?vue&type=style&index=0&id=1cddd22c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__